"use strict";

exports.__esModule = true;
exports.chainCallbacks = chainCallbacks;

function chainCallbacks() {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }

  return function func() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    callbacks.forEach(function (callback) {
      if (typeof callback === 'function') {
        callback == null ? void 0 : callback.apply(void 0, args);
      }
    });
  };
}